import { z } from 'zod';

const HEX_COLOR = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const AUI_TOKEN_REFERENCE = /^var\(--aui-[a-z0-9-]+\)$/;

// Kept as an allowlist: CSS escapes, image-set() and var() fallbacks load a URL past a `url(` denylist or CSS.supports.
export const CssColorSchema = z
  .string()
  .refine(
    (value) => HEX_COLOR.test(value) || AUI_TOKEN_REFERENCE.test(value),
    'Expected a hex color such as #0e63ff or an AUI token reference such as var(--aui-neutral-900)'
  );
